{
  "enum": {
    "J5DrssV1StepStatus": {
      "ACTIVE": "Active",
      "BLOCKED": "Blocked",
      "DONE": "Done",
      "FAILED": "Failed",
      "READY": "Ready",
      "UNSPECIFIED": "Unspecified"
    }
  }
}